import { ColumnHeader } from '@/interfaces/components/ColumnHeader';

const headers: ColumnHeader[] = [
  { text: 'venue.loyaltyManagedGifts.name', value: 'name', sortable: true },
  { text: 'venue.loyaltyManagedGifts.type', value: 'giftType', sortable: true },
  { text: 'venue.loyaltyManagedGifts.status', value: 'status', sortable: true },
  { text: 'venue.loyaltyManagedGifts.requiredPoints', value: 'requiredPoints', sortable: true },
];

export default headers;
